"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var recompose_1 = require("recompose");
var styled_components_1 = require("styled-components");
var hocs_1 = require("../hocs");
var AccordionContext_1 = require("../Accordion/AccordionContext");
var BasicAccordionPanel_1 = require("../BasicAccordionPanel");
var AccordionPanel = function (props) {
    return (React.createElement(AccordionContext_1.AccordionContext.Consumer, null, function (panelContext) {
        var active = panelContext.active, animate = panelContext.animate, onPanelChange = panelContext.onPanelChange;
        return React.createElement(BasicAccordionPanel_1.BasicAccordionPanel, tslib_1.__assign({ active: active, animate: animate, onClick: onPanelChange }, props));
    }));
};
var AccordionPanelWrapper = recompose_1.compose(styled_components_1.withTheme, hocs_1.withForwardRef)(AccordionPanel);
exports.AccordionPanel = AccordionPanelWrapper;
//# sourceMappingURL=AccordionPanel.js.map